import { GET, POST, UPDATE } from "./";

const apiNotification = {
    get: (data) => GET(`/api/notification/${data.companyId}/${data.typeAccount}`),
    update: (data) => UPDATE(`/api/notification`, data),
}

export { apiNotification };